// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "./Layer";

export default function CounterAssociates() {
	const Icon = getOutlinedPositionIcon({ position: "Parts Counter Associate" });
	return (
		<PageLayer title={"Parts Counter Associate Pay Plans"} icon={Icon}>
			<Layer />
		</PageLayer>
	);
}
